module.exports = __webpack_public_path__ + "images/emoji/facepunch.3ca75e1d84eaeea88a82.png";